/* GASSISA
=========================================================================================
 * Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
 *    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
 * ---------------------------------------------------------------------------------------
 *      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Se renombra Verificador IA a Asistencia en piso
*      3       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Se agrega laboratorio Ticket ventas master
*      4       | 04/06/2026 | Lic. José Luis Aragón Cervantes  | Se homologan títulos de rutas con esquemas de accesos
 *      5       | 31/08/2026 | Lic. José Luis Aragón Cervantes  | Titulo de ruta para registro de fallos
 * ---------------------------------------------------------------------------------------
 */

export const routeBase = "/";
export const routeRoot = "/*";
export const routeLogin = "/login";
export const routeTenantAdminPasswordRecovery = "/recuperaciontenantadmin";
export const routeMain = "/leyout";
export const routeLanding = "/Landing";
export const routeDashboard = "/dashboard";
export const routeAcercaDe = "/SizeSoftXAcercaDe";
export const routeSistem = "/sizesoftx";

export const routeTitles = {
  "/": "Dashboard",
  "/login": "Login",
  "/recuperaciontenantadmin": "Recuperación password",
  "/ventas": "Ventas",
  "/preventas": "Preventas",
  "/apartados": "Apartados",
  "/entradas": "Entradas",
  "/salidas": "Salidas",
  "/parametrosestacion": "Parámetros de Caja",
  "/parametrosticketmaster": "Ticket ventas master",
  "/existencias": "Existencias",
  "/cortesdecaja": "Cortes de caja",
  "/cuentasxcobrar": "Cuentas X Cobrar",
  "/traslados": "Traslados",
  "/devoluciones": "Devoluciones",
  "/articulos": "Artículos",
  "/accesos": "Accesos",
  "/clientes": "Clientes",
  "/proveedores": "Proveedores",
  "/almacenesexhibidores": "Almacenes y Exhibidores",
  "/corridas": "Corridas",
  "/verificador": "Verificador",
  "/asistenciapiso": "Asistencia en piso",
  "/etiquetado": "Etiquetado",
  "/tomainventario": "Toma de Inventario",
  "/reporteventasalmacen": "Reporte de Ventas",
  "/reimpresioncaja": "Reimpresión de Caja",
  "/pagocomisiones": "Pago de Comisiones",
  "/compras": "Compras",
  "/iaentrenamiento": "Entrenamiento IA",
  "/centrocostos": "Centro de Costos",
  "/controlasistencia": "Control de Asistencias",
  "/nominas": "Nóminas",
  "/conteosescaneo": "Escaneo de Conteos",
  "/registrofallos": "Registro de fallos",
};

